import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BillingFacade } from '@app/shared/+state/billing';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotExpiredGuard  {
  constructor(
    private readonly billingFacade: BillingFacade,
    private readonly router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.billingFacade.notExpiredCheck$.pipe(
      map((notExpired) => (notExpired ? true : this.router.createUrlTree(['/settings', 'your-plan'])))
    );
  }
}
